import apiClient from '../apiClient';

const API_URL = '/art/siniestros';

// Obtener todos los siniestros (opcionalmente filtrar por trámite)
export const getSiniestros = async (idTramite = null) => {
    const params = {};
    if (idTramite) params.idTramite = idTramite;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Obtener siniestros por trámite (endpoint dedicado)
export const getSiniestrosPorTramite = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/tramite/${idTramite}`);
    return response.data;
};

// Obtener siniestro por ID
export const getSiniestroPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear siniestro
export const crearSiniestro = async (data) => {
    const response = await apiClient.post(API_URL, data);
    return response.data;
};

// Actualizar siniestro
export const actualizarSiniestro = async (id, data) => {
    const response = await apiClient.put(`${API_URL}/${id}`, data);
    return response.data;
};

// Eliminar siniestro
export const eliminarSiniestro = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

